var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHunterXterRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5894,
    cy: 21,
    r: 20.5,
    fill: "#4C1506",
    fillOpacity: 0.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5737 16.4468C24.5466 15.463 23.2504 14.2269 21.7341 14.9332C21.196 15.1855 20.8046 15.8666 20.609 16.4721L14.5192 16.4721C13.0273 16.4721 11.8045 17.7334 11.8045 19.2722L11.8045 23.5103C11.8045 25.0491 13.0273 26.3104 14.5192 26.3104L20.5601 26.3104C20.878 27.4708 22.003 28.3285 23.1525 27.9753C24.3998 27.5969 25.2803 26.714 26.2341 25.8563C26.9189 25.2257 27.9706 24.0652 28.5331 22.9048C29.7315 20.4074 27.1879 18.0109 25.5737 16.4468Z",
    fill: "#FFB6A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterXterRight);
export default __webpack_public_path__ + "static/media/hunter-xter-right.573709dbb0c4a1458d6b1ea42ec0ca11.svg";
export { ForwardRef as ReactComponent };